// import { io } from 'socket.io-client'; // DISABLED to prevent runaway requests
import toast from "react-hot-toast";
import { safeGet, safePost, safeDelete } from '../../../config/axiosClient.js';

export const getDepartureData = () => {
    return async dispatch => {
        // Fetch both arrival and departure data since ads are stored in arrival collection
        const [arrivalResult, departureResult] = await Promise.all([
            safeGet('/api/arrival'),
            safeGet('/api/departure')
        ]);

        // If both failed, don't update state
        if (arrivalResult.error && departureResult.error) {
            // Logged by axiosClient, app will retry on next poll
            return;
        }

        let combinedData = [];

        if (arrivalResult.data?.success) {
            combinedData = [...combinedData, ...arrivalResult.data.data];
        }

        if (departureResult.data?.success) {
            combinedData = [...combinedData, ...departureResult.data.data];
        }

        dispatch({
            type: "Set_Departure_Data",
            data: combinedData
        });
    };
}

export const setDepartureData = (returnArray) => {
    return dispatch => {
        let data_array = [...returnArray];
        dispatch({
            type: "Set_Departure_Data",
            data: data_array
        })
    }


}

export const deleteDepartureData = (id) => {
    return async dispatch => {
        const { data, error } = await safeDelete(`/api/departure/${id}`);

        if (error) {
            console.error('Error deleting departure data:', error.message);
            if (!error.isOffline) {
                toast.error('Failed to delete item');
            }
            return;
        }

        if (data?.success) {
            dispatch({
                type: "Set_Departure_Data",
                data: data.data
            });
        }
    };
}

export const addDepartureData = (formData) => {
    return async dispatch => {
        const { data, error } = await safePost('/api/upload', formData);

        if (error) {
            console.error('Error adding departure data:', error.message);
            if (!error.isOffline) {
                toast.error('Failed to upload');
            }
            return;
        }

        if (data?.data) {
            let resp = [...data.data];
            let array_data = [];

            resp.forEach((file, index) => {
                let item = {
                    Id: resp._id,
                    CompanyName: resp.companyName,
                    Airport: resp.Airport,
                    Wing: "arrival",
                    Image: resp.uploadFile,
                    Type: resp.type
                };
                array_data.push(item);
                if (index === (resp.length - 1)) {
                    dispatch({
                        type: "Set_Departure_Data",
                        data: array_data
                    });
                }
            });
        }
    };
}